
import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import { BContainer, BRow, BCol, BButton } from "bootstrap-vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import CardNotTicket from "@/components/card/CardNotTicket.vue";
import ModalLinkProgressChat from "@/components/modal/ModalLinkProgressChat.vue";
import TicketModel from "@/models/createTicket/TicketModel";
import { UserModule } from "@/store/modules/user";
import { HomeModule } from "@/store/modules/home";
import ModalLinkAction from "@/components/modal/ModalLinkAction.vue";

import utils from "@/utils";
import api from "@/api";
@Component({
    components: {
        BRow,
        BContainer,
        BCol,
        BButton,
        MenuFooter,
        ModalLinkProgressChat,
        CardNotTicket,
        ModalLinkAction,
    },
})
export default class Home extends Vue {
    mounted() {
        // Check if coming from create ticket pages
        const fromCreateTicket = this.isComingFromCreateTicket();
        
        if (fromCreateTicket) {
            // Load fresh data when coming from create ticket
            this.displayLoading = true;
            this.loadTicket();
        } else if (HomeModule.isDataLoaded && HomeModule.listTicket.length > 0) {
            // Restore state from store
            this.restoreState();
            // Restore scroll position after component is fully mounted
            this.$nextTick(() => {
                setTimeout(() => {
                    this.restoreScrollPosition();
                }, 100);
            });
        } else {
            // Load fresh data
            this.displayLoading = true;
            this.loadTicket();
        }
        
        // Add scroll listener to continuously save position
        window.addEventListener('scroll', this.onScroll);
    }

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    }

    activated() {
        // Check if coming from create ticket pages
        const fromCreateTicket = this.isComingFromCreateTicket();
        
        if (fromCreateTicket) {
            // Reset state and load fresh data when coming from create ticket
            this.displayLoading = true;
            this.loadTicket();
        } else if (HomeModule.isDataLoaded && HomeModule.listTicket.length > 0) {
            // Restore state for normal navigation
            this.restoreState();
            // Restore scroll position after DOM update with delay
            this.$nextTick(() => {
                setTimeout(() => {
                    this.restoreScrollPosition();
                }, 300); // Give time for DOM to fully render
            });
        }
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        // Only save state if not going to create ticket pages
        if (!this.isGoingToCreateTicket(to)) {
            this.saveState();
        }
        next();
    }

    username = "Jhonatan";
    displayTicketKosong = false;
    displayListTicket = true;
    displayLoading = false;
    utils = utils;
    userDetail = UserModule.userDetail;
    isLoading = false;
    scrollTimeout: any = null;

    // Computed properties to use store state
    get listTicket(): TicketModel[] {
        return HomeModule.listTicket;
    }

    get currentPage(): number {
        return HomeModule.currentPage;
    }

    get hasMorePages(): boolean {
        return HomeModule.hasMorePages;
    }

    @Ref() modalLink!: ModalLinkProgressChat;
    @Ref() modalLink1!: ModalLinkAction;

    loadTicket() {
        return new Promise((resolve, reject) => {
            if (this.userDetail.accessgroup["name"] !== "User") {
                this.isLoading = true;
                api.ticket
                    .getMyTask2(HomeModule.currentPage)
                    .then((response) => {
                        this.isLoading = false;
                        if (response.data.code === 200) {
                            const newTickets = response.data.data.map((e) => ({
                                closed:
                                    e.tiket_status == "Closed" ||
                                    e.tiket_status == "Rejected" ||
                                    e.status == "Technical completion",
                                ...e,
                            }));

                            if (HomeModule.currentPage === 1) {
                                HomeModule.setListTicket(newTickets);
                            } else {
                                HomeModule.appendListTicket(newTickets);
                            }

                            const meta = response.data.meta;
                            HomeModule.setHasMorePages(
                                meta.current_page < meta.last_page
                            );
                            this.displayLoading = false;
                            HomeModule.setDataLoaded(true);

                            const jumlahNew = HomeModule.listTicket.filter(
                                (item) => !item.closed
                            ).length;
                            if (jumlahNew === 0) {
                                this.displayTicketKosong = true;
                                this.displayListTicket = false;
                            } else {
                                this.displayTicketKosong = false;
                                this.displayListTicket = true;
                            }
                            resolve(response);
                        }
                    })
                    .catch((err) => {
                        this.displayLoading = false;
                        reject(new Error(err));
                    });
            } else {
                this.isLoading = true;
                api.ticket
                    .getMyTicket2(HomeModule.currentPage)
                    .then((response) => {
                        if (response.data.code === 200) {
                            const newTickets = [
                                ...response.data.data.data.map((e) => ({
                                    closed:
                                        e.tiket_status == "Closed" ||
                                        e.tiket_status == "Rejected" ||
                                        e.status == "Technical completion",
                                    ...e,
                                })),
                            ];

                            if (HomeModule.currentPage === 1) {
                                HomeModule.setListTicket(newTickets);
                            } else {
                                HomeModule.appendListTicket(newTickets);
                            }

                            HomeModule.setHasMorePages(
                                response.data.data.current_page <
                                response.data.data.last_page
                            );
                            this.displayLoading = false;
                            this.isLoading = false;
                            HomeModule.setDataLoaded(true);

                            let jumlahNew = HomeModule.listTicket.filter(
                                (item) => !item.closed
                            ).length;
                            if (jumlahNew === 0) {
                                this.displayTicketKosong = true;
                                this.displayListTicket = false;
                            } else {
                                this.displayTicketKosong = false;
                                this.displayListTicket = true;
                            }
                            resolve(response);
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        reject(new Error(err));
                    });
            }
        });
    }

    loadMore() {
        HomeModule.setCurrentPage(HomeModule.currentPage + 1);
        this.loadTicket();
    }

    onScroll() {
        // Throttle scroll saving to avoid too many calls
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.saveScrollPosition();
        }, 100);
    }

    saveScrollPosition() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        HomeModule.setScrollPosition(scrollPosition);
        sessionStorage.setItem('homeScrollPosition', scrollPosition.toString());
    }

    saveState() {
        // Save scroll position
        this.saveScrollPosition();
        
        // Save other state to sessionStorage as backup
        sessionStorage.setItem('homeCurrentPage', HomeModule.currentPage.toString());
        sessionStorage.setItem('homeListTicket', JSON.stringify(HomeModule.listTicket));
        sessionStorage.setItem('homeHasMorePages', HomeModule.hasMorePages.toString());
    }

    restoreState() {
        // Update display state based on tickets
        const jumlahNew = HomeModule.listTicket.filter(
            (item) => !item.closed
        ).length;
        
        if (jumlahNew === 0) {
            this.displayTicketKosong = true;
            this.displayListTicket = false;
        } else {
            this.displayTicketKosong = false;
            this.displayListTicket = true;
        }
        
        this.displayLoading = false;
    }

    restoreScrollPosition() {
        // Only restore scroll if we're actually on the Home page
        if (this.$route.name !== 'home' && this.$route.path !== '/') {
            return;
        }
        
        // Try to restore from store first, then sessionStorage
        let scrollPosition = HomeModule.scrollPosition;
        
        if (scrollPosition === 0) {
            const savedPosition = sessionStorage.getItem('homeScrollPosition');
            scrollPosition = savedPosition ? parseInt(savedPosition, 10) : 0;
        }
        
        if (scrollPosition > 0) {
            // Use immediate scrolling without smooth behavior to avoid timing issues
            window.scrollTo(0, scrollPosition);
        }
    }

    

    showModal(ticket: any, activemenu: Activemenumodel) {
        // Save scroll position before opening modal
        this.saveState();
        this.modalLink1.showModal(ticket, activemenu);
    }

    // Helper method to check if coming from create ticket pages
    isComingFromCreateTicket(): boolean {
        const createTicketRoutes = ['create-ticket', 'CreateTicket', 'CreateTicketOpr'];
        const referrer = document.referrer;
        const fromRoute = this.$router.currentRoute.query.from as string;
        
        // Check if coming from create ticket route via query param or referrer
        if (fromRoute && createTicketRoutes.includes(fromRoute)) {
            return true;
        }
        
        // Check referrer URL for create ticket paths
        if (referrer && (referrer.includes('/create-ticket') || referrer.includes('/CreateTicket'))) {
            return true;
        }
        
        // Check session storage for create ticket flag
        const fromCreateTicket = sessionStorage.getItem('fromCreateTicket');
        if (fromCreateTicket === 'true') {
            sessionStorage.removeItem('fromCreateTicket');
            return true;
        }
        
        return false;
    }

    // Helper method to check if going to create ticket pages
    isGoingToCreateTicket(to: any): boolean {
        const createTicketRoutes = ['create-ticket', 'CreateTicket', 'CreateTicketOpr'];
        return createTicketRoutes.includes(to.name) || 
               (to.path && (to.path.includes('/create-ticket') || to.path.includes('/CreateTicket')));
    }
}

class Activemenumodel {
    assesment: number | undefined;
    additional_resource: number | undefined;
    work_order_feedback: number | undefined;
    work_order_history: number | undefined;
    chat: number | undefined;
    work_order_activity: number | undefined;
}
